module.exports = __webpack_public_path__ + "static/media/1562555.1ffd515c.jpg";